<script lang="ts">
let {
    placeholder = '',
    name = '',
    role = '',
    isInvalid = false,
    inputElement = $bindable(),
    valueObject = $bindable(),
    ...rest
} = $props();
</script>

<input
    class="field"
    class:field--invalid={isInvalid}
    type="tel"
    autocomplete="tel"
    {placeholder}
    {name}
    {role}
    bind:value={valueObject}
    bind:this={inputElement}
    {...rest}
/>

<style lang="scss">
    @use '/src/scss/global-constants/fonts';
    @use 'sass-mq/mq' as *;

    .field {
        appearance: none;
        background: none;
        border-color: var(--colour-squant);
        border-style: solid;
        border-width: 0 0 1px;
        color: var(--colour-dreamless-sleep);
        font-family: fonts.$fonts-secondary;
        font-size: 1.6rem;
        font-weight: fonts.$fonts-weight--normal;
        line-height: 1.6;
        margin: 0 0 3rem;
        width: 100%;

        @include mq($from: tablet) {
            margin: 0 0 4rem;
        }

        &:focus {
            border-color: var(--colour-lucky-grey);
        }

        &:disabled {
            background-color: var(--colour-crisp-muslin);
            -webkit-text-fill-color: var(--colour-dreamless-sleep);
            opacity: 0.7;
        }

        &:invalid {
            box-shadow: none;
        }

        &--invalid {
            border-color: var(--colour-sacrifice-altar) !important;
        }
    }
</style>
